module.exports = "https://cdn.hellotech.com/client-assets/routers_tablet_e99b6ea1ce8ef40cf6b56a435318920a.webp";